import { AuthState } from '@okta/okta-auth-js';

import { AllocatedCommission } from '../../services/backend/AllocatedCommission';
import { useBaseApiClient } from '../useBaseApiClient';

export const useAllocatedCommission: () => AllocatedCommission<AuthState> = () => {
  return useBaseApiClient(AllocatedCommission);
};
